import React from "react";

/**
 * LnhBadge — clickable LNH logo that replaces the textual "LNH" label.
 * Always opens https://www.lnh.fr/accueil in a new tab.
 *
 * Sizes (matches Tailwind text scale):
 *  - sm  → 18px height
 *  - md  → 24px height (default)
 *  - lg  → 32px height
 *  - xl  → 44px height
 */
const SIZES = {
  sm: "h-[18px]",
  md: "h-6",
  lg: "h-8",
  xl: "h-11",
};

const LNH_LOGO = "https://customer-assets.emergentagent.com/job_d6b30d32-0560-4729-9096-ffa84a0b3e19/artifacts/f4w8n4sg_image.png";

export function LnhBadge({ size = "md", className = "", inline = true, "data-testid": testid = "lnh-badge" }) {
  const sizeCls = SIZES[size] || SIZES.md;
  return (
    <a
      href="https://www.lnh.fr/accueil"
      target="_blank"
      rel="noopener noreferrer"
      title="Voir sur le site officiel de la LNH"
      className={`${inline ? "inline-flex" : "flex"} items-center align-middle hover:opacity-80 transition ${className}`}
      data-testid={testid}
      onClick={(e) => e.stopPropagation()}
    >
      <img src={LNH_LOGO} alt="LNH" className={`${sizeCls} w-auto object-contain`} loading="lazy"/>
    </a>
  );
}

export default LnhBadge;
